export type WorkspaceProjectionDiagnostic = {
  atEpochMs: number;
  stage: string;
  changeType?: string;
  reason?: string;
  docIds?: string[];
  folderIds?: string[];
};

declare global {
  interface Window {
    __gatWorkspaceProjectionDiagnostics?: WorkspaceProjectionDiagnostic[];
  }
}

const MAX_GAT_PROJECTION_DIAGNOSTICS = 300;

/**
 * Bounded, GAT-only projection trace. The browser-owner harness creates the
 * buffer before app bootstrap; normal product sessions pay no network or
 * persistence cost and return immediately.
 */
export function recordWorkspaceProjectionDiagnostic(
  diagnostic: Omit<WorkspaceProjectionDiagnostic, 'atEpochMs'>
): void {
  if (typeof window === 'undefined') return;
  const buffer = window.__gatWorkspaceProjectionDiagnostics;
  if (!Array.isArray(buffer)) return;
  buffer.push({ atEpochMs: Date.now(), ...diagnostic });
  if (buffer.length > MAX_GAT_PROJECTION_DIAGNOSTICS) {
    buffer.splice(0, buffer.length - MAX_GAT_PROJECTION_DIAGNOSTICS);
  }
}
